<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center pb-4">
      <img src="assets/img/svg/T.svg" alt="Tracey logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 align-self-start">
        <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
        </button>
      </div>
    </div>
    <div class="body-wrapper">
      <form [formGroup]="inputForm">
        <div class="row pb-4">
          <div class="col-12 col-xl-6">
            <div class="pb-3">
              <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [required]="true"
                                  [extraLanguages]="event?.extraLanguages" [hrKey]="'name'" [enKey]="'nameEng'"
                                  [itKey]="'nameIta'" [srKey]="'nameSr'" [bsKey]="'nameBs'"
                                  [siKey]="'nameSlo'" [hrLabel]="'race.pricing.additional.items.displayName'"
                                  [enLabel]="'race.pricing.additional.items.displayName.en'"
                                  [srLabel]="'race.pricing.additional.items.displayName.sr'"
                                  [bsLabel]="'race.pricing.additional.items.displayName.bs'"
                                  [itLabel]="'race.pricing.additional.items.displayName.it'"
                                  [siLabel]="'race.pricing.additional.items.displayName.sl'"/>
            </div>
            <div class="pb-3">
              <app-input formControlName="additionalTextField"
                         label="race.pricing.additional.items.additionalTextField"/>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="pb-3">
              <app-textarea id="internalDescription" formControlName="internalDescription"
                            label="race.pricing.additional.items.internalDescription"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-6">
            @if (inputForm.controls.priceConstant.value) {
              <div class="pb-3">
                <app-input formControlName="price" type="decimal" class="mb-3"
                           [translatedLabel]="t('race.pricing.additional.items.priceWithVAT') +' (' + getCurrencyLabel() + ')'"
                           [translatedPlaceholder]="t('race.pricing.additional.items.priceWithVAT') + ' (' + getCurrencyLabel() + ')'"/>
              </div>
            }
            <div class="pb-3">
                <app-input formControlName="vat" type="decimal" class="mb-3"
                           [translatedPlaceholder]="t('race.pricing.additional.items.VATRate') + ' (%)'"
                           [translatedLabel]="t('race.pricing.additional.items.VATRate') + ' (%)'"/>
              </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="pb-4">
              <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [isInput]="false"
                                  [extraLanguages]="getExtraLanguages()" [hrKey]="'vatExplanation'" [required]="false"
                                  [enKey]="'vatExplanationEng'" [itKey]="'vatExplanationIta'"
                                  [siKey]="'vatExplanationSlo'" [srKey]="'vatExplanationSr'" [bsKey]="'vatExplanationBs'"
                                  [hrLabel]="'race.pricing.vatRateExplanation'"
                                  [enLabel]="'race.pricing.vatRateExplanation.en'"
                                  [itLabel]="'race.pricing.vatRateExplanation.it'"
                                  [srLabel]="'race.pricing.vatRateExplanation.sr'"
                                  [bsLabel]="'race.pricing.vatRateExplanation.bs'"
                                  [siLabel]="'race.pricing.vatRateExplanation.sl'"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6 pb-3">
            <app-select formControlName="fieldRegistrationDisplayFlag"
                        [items]="registrationDisplayFlags"
                        labelKeyPrefix="race.registration.settings.registrationDisplayFlags."
                        valueKey="id" labelKey="id" label="race.pricing.additional.items.displayLabelRegistration"/>
          </div>
          <div class="col-12 col-xl-6 pb-3">
            <app-select formControlName="fieldVisibility"
                        [items]="visibilityTypes" valueKey="id" labelKey="id"
                        labelKeyPrefix="race.settings.visibilityTypes."
                        label="race.pricing.additional.items.displayLabelParticipantList"/>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-6">
            <div class="form-floating my-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="fieldRequiredForRegistration"
                       formControlName="fieldRequiredForRegistration">
                <label class="form-check-label ms-3" for="fieldRequiredForRegistration">{{
                    t(
                      "race.pricing.additional.items.registrationFieldRequired")
                  }}
                  @if (inputForm.controls.fieldRequiredForRegistration.errors?.['required']) {
                    <span>*</span>
                  }</label>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div [ngClass]="{
            'fw-bold text-uppercase': pricingItemValues.controls.length  > 0,
            }">
            <div class="d-flex align-items-center" [ngClass]="{
            'justify-content-between': pricingItemValues.controls.length > 0,
            'justify-content-end': !(pricingItemValues.controls.length > 0)
            }">
              @if (pricingItemValues.controls.length > 0) {
                <span>{{ t('race.pricing.pricingItemValues') }}
              </span>
              }
              <app-rounded-button [label]="t('race.pricing.addNewPricingItemValue')" (onClick)="addPricingItemValue()"
                                  [isDisabled]="disableEditing" [btnClass]="'rounded-button--solid'"><i
                class="bi bi-plus-circle pe-2"></i></app-rounded-button>
            </div>
          </div>
        </div>
        @if (pricingItemValues.controls.length > 0) {
          <div class="row pb-2">
            <div class="col-12 col-xl-6">
              <div class="form-floating mt-3">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="priceConstant" formControlName="priceConstant">
                  <label class="form-check-label ms-3" for="priceConstant">{{
                      t(
                        "race.pricing.additional.items.priceConstant")
                    }} </label>
                </div>
              </div>
            </div>
          </div>
        }
        <ng-container formArrayName="pricingItemValues">
          @if (pricingItemValues.controls.length > 0) {
            <ul class="pricingItemValuesHolder pt-3" id="pricingItemValuesHolder">
              @for (periodForm of pricingItemValues.controls;track periodForm;let i = $index) {
                <li #pricingItemValue>
                  <ng-container [formGroupName]="i">
                    <div class="row" [ngClass]="{'pt-3': i!==0}">
                      <div class="col-8">
                        <app-language-input [inputForm]="pricingItemValueFormControl(i)"
                                            [defaultLanguage]="event?.defaultLanguage" [required]="true"
                                            [extraLanguages]="event?.extraLanguages" [hrKey]="'name'"
                                            [enKey]="'nameEng'" [itKey]="'nameIta'" [bsKey]="'nameBs'"
                                            [siKey]="'nameSlo'" [srKey]="'nameSr'" [hrLabel]="'race.pricing.additional.items.displayName'"
                                            [enLabel]="'race.pricing.additional.items.displayName.en'"
                                            [itLabel]="'race.pricing.additional.items.displayName.it'"
                                            [srLabel]="'race.pricing.additional.items.displayName.sr'"
                                            [bsLabel]="'race.pricing.additional.items.displayName.bs'"
                                            [siLabel]="'race.pricing.additional.items.displayName.sl'"/>
                      </div>
                      <div class="col-3">
                        <app-input formControlName="price" id="price{{i}}" type="decimal"
                                   [translatedLabel]="t('race.pricing.price') +' (' + getCurrencyLabel() + ')'"
                                   [translatedPlaceholder]="t('race.pricing.price') + ' (' + getCurrencyLabel() + ')'"/>
                      </div>
                      <div class="col-1" style="margin-top: 2.5rem;">
                        <div>
                      <span class="delete-icon" (click)="deletePricingItemValue(i)"><i
                        class="bi bi-trash-fill"></i></span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </li>
              }
            </ul>
          }
        </ng-container>
      </form>
    </div>
    <div class="d-flex justify-content-center align-items-center pb-40-48">
      <div class="d-flex">
        <div class="pe-3">
          <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--black-outline'"
                              (onClick)="onDismissClick()"/>
        </div>
        <app-rounded-button [label]="t('app.common.save')" (onClick)="onSave()"
                            [btnClass]="'rounded-button--solid'"></app-rounded-button>
      </div>
    </div>
  </div>
</ng-container>


